import { renderContent } from 'components/CalendarItemTypeElement'
import { CalendarPanelPopover } from 'components/calendarPanelPopover'
import { CalendarPanelPopoverLinkedPush } from 'components/calendarPanelPopover/components/CalendarPanelPopoverLinkedPush'
import { TailwindModal } from 'components/modal'
import { Tooltip } from 'components/tooltip'
import React from 'react'
import 'swiper/swiper-bundle.css'
import { CalendarEvent } from 'utils'
import { eventStyles } from 'utils/eventStyles/EventStyles'

export const CalendarEventItem: React.FC<{
	event: CalendarEvent
	quantityElement: number
	effectiveSlots?: number
}> = ({ event, quantityElement, effectiveSlots = 1 }) => {
	const { statusColor, text } =
		eventStyles[event.status] || eventStyles.published
	const [openContent, setOpenContent] = React.useState(false)
	const [openPush, setOpenPush] = React.useState(false)

	const isLinkedCase = !!event.has_notification

	const capitalizeFirstLetter = (str: string): string => {
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
	}

	return (
		<>
			<div className="h-full">
				<Tooltip
					text={capitalizeFirstLetter(event.status)}
					useInlineBlock={false}
					className="h-full"
				>
					<div
						className={`flex items-center h-full overflow-hidden rounded-l-[4px] rounded-r-[8px] bg-white border border-[#F2F2F2] shadow-md ${
							event.card_expirated && '!opacity-50'
						} `}
						onClick={isLinkedCase ? undefined : () => setOpenContent(true)}
						onKeyDown={
							isLinkedCase
								? undefined
								: e => e.key === 'Enter' && setOpenContent(true)
						}
						role="button"
						tabIndex={0}
						aria-label={`Open details for ${event.title || 'event'}`}
					>
						<div
							className={`w-[6px] flex-shrink-0 self-stretch ${statusColor}`}
						/>
						<div className="flex-1 min-w-0 overflow-hidden">
							<li key={event.id} className="w-full overflow-hidden">
								{renderContent(
									event,
									quantityElement,
									text,
									isLinkedCase ? () => setOpenContent(true) : undefined,
									isLinkedCase ? () => setOpenPush(true) : undefined,
									effectiveSlots
								)}
							</li>
						</div>
					</div>
				</Tooltip>
			</div>

			<TailwindModal
				open={openContent}
				setOpen={setOpenContent}
				className="w-[400px] max-h-[35rem] 1lg:max-h-[50rem] p-4 rounded-[16px]"
			>
				<CalendarPanelPopover event={event} />
			</TailwindModal>

			{isLinkedCase && (
				<TailwindModal
					open={openPush}
					setOpen={setOpenPush}
					className="w-[400px] max-h-[35rem] 1lg:max-h-[50rem] p-4 rounded-[16px]"
				>
					<CalendarPanelPopoverLinkedPush event={event} />
				</TailwindModal>
			)}
		</>
	)
}

CalendarEventItem.defaultProps = {
	effectiveSlots: 1
}
